import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerToggleComponent } from './drawer-toggle/drawer-toggle.component';
import {SharedModule} from '../../shared/shared.module';
import { DrawerMenuComponent } from './drawer-menu/drawer-menu.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    DrawerToggleComponent,
    DrawerMenuComponent
  ],
  declarations: [DrawerToggleComponent, DrawerMenuComponent]
})
export class DrawerModule { }



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/drawer/drawer.module.ts